// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.
import styles from './Bar.module.css';

export type BarTone = 'ok' | 'warn' | 'err' | 'info' | 'accent' | 'idle';

export interface BarRow {
  label: string;
  count: number;
  pct: number;
  tone: BarTone;
}

const TONE_CLASSES: Record<BarTone, string> = {
  ok: styles.toneOk,
  warn: styles.toneWarn,
  err: styles.toneErr,
  info: styles.toneInfo,
  accent: styles.toneAccent,
  idle: styles.toneIdle,
};

export default function Bar({ label, count, pct, tone }: BarRow) {
  return (
    <div className={styles.bar}>
      <span className={styles.barHead}>
        <span className={styles.barLabel}>{label}</span>
        <span className={styles.barMeta}>
          {count} · {pct}%
        </span>
      </span>
      <span className={styles.track}>
        <span
          className={`${styles.fill} ${TONE_CLASSES[tone]}`}
          style={{ width: `${pct}%` }}
          data-testid="bar-fill"
        />
      </span>
    </div>
  );
}
